<template>
<div>
  <div v-for="(agent, key) in this.agentdata">

    <div v-bind:class="{ show: showItem }" class="agentcard ut-card-v1" :data-id="agent.AgentId">

      <div class="topsection">
        <img class="ut-headshot-sm ut-content-center ut-flex" v-bind:src="agent.AgentImageLink" />
        <div class="lg:ut-pl-4">
          <div class="ut-text-center ut-font-semibold ut-text-xl ut-py-2 lg:ut-text-left">{{agent.AgentName}}</div>
          <div class="ut-text-center ut-text-sm lg:ut-text-left">{{agent.AgencyName}}</div>
        </div>
      </div>

      <div class="statsection ut-text-center lg:ut-text-left">
        <div class="statblock lg:ut-inline" v-if="agent.SoldHouses">
          <div class="statvalue">{{agent.SoldHouses}}</div>
          Houses sold
        </div>
        <div class="statblock lg:ut-inline-block" v-if="agent.SoldApartments">
          <div class="statvalue">{{agent.SoldApartments}}</div>
          Units sold
        </div>
        <div class="statblock lg:ut-inline" v-if="agent.HighSalePrice">
          <div class="statvalue">{{agent.HighSalePrice}}</div>
          Highest Sale
        </div>
      </div>

      <div class="btmsection">

        <router-link :to="{name: 'RequestAppraisalStep1', query: { ak: agent.AgentKey }}" v-gaEvent="{ category: gacategory, action: 'Click Request Appraisal', label: `Agent ID ${agent.AgentId}`}" class="ut-oa-btn ut-block">Get a free appraisal</router-link>

        <div v-if="agent.hideMe == undefined || agent.hideMe == false" @click="addToList(agent)" v-gaEvent="{ category: gacategory, action: 'Click Add to Contact list', label: `Agent ID ${agent.AgentId}`}" class="ut-text-center ut-text-Gnew ut-font-medium ut-pt-4 ut-cursor-pointer">
          <img class="ut-w-3 ut-pr-1" src="@/assets/styles/frontend-library/images/plusv2.svg" /> Add to shortlist</div>

        <div v-if="agent.hideMe == true" @click="removeFromList(agent)" v-gaEvent="{ category: gacategory, action: 'Click Remove from Contact list', label: `Agent ID ${agent.AgentId}`}" class="ut-text-center ut-text-N200 ut-font-medium ut-pt-4 ut-cursor-pointer">
          <img class="ut-w-3 ut-pr-1" src="@/assets/styles/frontend-library/images/minus.svg" /> Remove from shortlist</div>

      </div>

    </div>

  </div>
</div>
</template>

<script>
export default {
  name: 'AgentCard',
  props: {
    agentdata: null,
  },
  data() {
    return {
      gacategory: "Directory with smart search",
      contactList: [],
      showItem: true,
    };
  },
  methods: {
    addToList(agent) {
      if (this.$store.state.agentContactList != undefined) {
        this.contactList = this.$store.state.agentContactList;
      }
      let isNew = true;
      for (let i = 0; i < this.contactList.length; i++) {
        if (this.contactList[i].AgentKey == agent.AgentKey) {
          isNew = false;
        }
      }
      if (isNew && this.contactList.length < 3) {
        this.contactList.push(agent);
        this.$store.state.contactList = this.contactList;
        this.$emit('addToList', this.contactList);
        Object.assign(agent, {
          hideMe: true
        });
        this.$forceUpdate();
      } else if (this.contactList.length >= 3) {
        this.$emit('cannotAdd');
      }
      this.$store.state.agentContactList = this.contactList;
    },
    removeFromList(agent) {
      if (this.$store.state.agentContactList != undefined) {
        this.contactList = this.$store.state.agentContactList;
      }
      for (let i = 0; i < this.contactList.length; i++) {
        if (this.contactList[i].AgentKey == agent.AgentKey) {
          this.contactList.splice([i], 1);
          Object.assign(agent, {
            hideMe: false
          });
        }
      }
      this.$store.state.agentContactList = this.contactList;
      this.$forceUpdate();
    },
  },
  mounted() {},
  created() {},
};
</script>

<style lang="scss" scoped>
.agentcard {
    margin: -30px 1rem 1rem;
    padding: 25px;
    border: 1px solid rgba(0,0,0,0.08);
    box-shadow: 0 14px 26px -6px rgba(0,0,0,0.19);
    border-radius: 4px;
    background-color: #fff;
    margin-bottom: 3rem;

    -webkit-animation: fadein 0.5s;
    -moz-animation: fadein 0.5s;
    -ms-animation: fadein 0.5s;
    -o-animation: fadein 0.5s;
    animation: fadein 0.5s;

    @screen lg {
        display: flex;
    }

    .topsection {
        padding-bottom: 20px;
        margin-bottom: 10px;
        border-bottom: 1px solid rgba(151,151,151, 0.2);

        @screen lg {
            display: flex;
            border-bottom: 0;
            border-right: 1px solid rgba(151,151,151, 0.2);
            padding-right: 2rem;
            flex: 1 1 auto;
            padding-bottom: 0;
            margin-bottom: 0;
            max-width: 300px;

        }
    }

    .statsection {
        display: flex;
        justify-content: center;
        padding-bottom: 15px;
        margin-bottom: 20px;
        border-bottom: 1px solid rgba(151,151,151, 0.2);

        @screen lg {
            margin: 0;
            border-bottom: 0;
            border-right: 1px solid rgba(151,151,151, 0.2);
            padding-right: 2rem;
            padding-left: 2rem;
            flex: 1 1 auto;
            padding-bottom: 0;
            max-width: 350px;

        }

        .statblock {
            @screen lg {
                min-width: 130px;
            }
        }

        .statvalue {
            @apply ut-text-lg ut-font-semibold;
            @screen lg {
                @apply ut-text-xl;
            }
        }
    }

    .btmsection {
        @screen lg {
            padding-left: 20px;
            flex: 1 1 auto;
            max-width: 200px;
        }
    }
    .ut-oa-btn {
        min-width: 210px;
    }
}
</style>
